import { Colors } from '@/components/ui/types';

export const PERFORMANCE_SUCCESS_THRESHOLD = 80;
export const PERFORMANCE_WARNING_THRESHOLD = 50;

export const performanceColor = (performance: number): Colors => {
  if (performance >= PERFORMANCE_SUCCESS_THRESHOLD) return 'success';
  if (performance >= PERFORMANCE_WARNING_THRESHOLD) return 'warning';
  return 'error';
};
